import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import DeviceTableDto from 'app/admin/device/dto/DeviceTableDto';
import NamedDto from 'modules/base/dto/NamedDto';
import EventSeverity from './EventSeverity';

export default class EventTableDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {Date} */
		this.timestamp = null;
		/** @type {string} */
		this.text = null;
		/** @type {string} */
		this.severity = null;
		/** @type {DeviceTableDto} */
		this.device = null;
		/** @type {NamedDto} */
		this.project = null;
	}

	/**
	 * @typedef {Object} _EventTableDtoProps
	 * @property {Date} timestamp
	 * @property {string} text
	 * @property {string} severity
	 * @property {DeviceTableDto} device
	 * @property {NamedDto} project
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _EventTableDtoProps} EventTableDtoProps
	 */
	/**
	 *
	 * @param {EventTableDtoProps} props
	 * @returns {EventTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.timestamp = props.timestamp !== null ? new Date(props.timestamp) : null;
		this.text = props.text;
		this.severity = props.severity;
		this.device = props.device !== null ? new DeviceTableDto().setup(props.device) : null;
		this.project = props.project !== null ? new NamedDto().setup(props.project) : null;
		return this;
	}

	getAsString(key) {
		if (key === 'severity') {
			return this.severity != null ? EventSeverity[this.severity] : '';
		}
		return super.getAsString(key);
	}
}
